import * as actionTypes from '../actions/types';

export const actualizarAtriutoVentanaDialogo = (objeto) => (dispatch) => {
    dispatch({
        type: actionTypes.ACTUALIZAR_ATRIBUTOS_VENTANA,
        payload: objeto,
    });
};
